import { cx } from '@libs/classnames';
import { ModalCard } from '@ui/components/ModalCard';
import { PageTitle } from '@ui/components/PageTitle';
import { ThemeLink } from '@ui/components/ThemeLink';

import { PromotedClubBackground } from '@features/club/ui/PromotedClubs/PromotedClubBackground';
import styles from '@features/club/ui/PromotedClubs/PromotedClubs.module.css';

export function StartYourOwnClubBanner({
  className,
  isModalOpen,
  openModal,
  closeModal,
}: {
  className?: string;
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}) {
  return (
    <>
      <div className={cx(styles.startYourOwnClubBanner, className)} onClick={openModal}>
        <div className={styles.header}>
          <div className={styles.title}>Хотите открыть свой клуб?</div>
        </div>

        <div className={styles.row}>
          <div className={styles.info}>
            <span>Платформа готова принимать новых организаторов</span>
          </div>

          <div className={styles.joinButton}>Подать заявку ›</div>
        </div>

        <PromotedClubBackground color="#F0DDC1" />
      </div>

      {isModalOpen && (
        <ModalCard title="Шахматные онлайн-клубы" onClose={closeModal}>
          <PageTitle className={styles.modalTitle}>
            Как открыть собственный шахматный клуб на ChessOpen
          </PageTitle>
          <div className={styles.modalText}>
            <p>
              Наша платформа всегда рада видеть людей, увлеченных шахматами. Если вы откроете
              собственный шахматный клуб, вы получите все функции платформы, которые мы используем
              сами, в том числе:
            </p>

            <ul>
              <li>Возможность ручного добавления участников</li>
              <li>Публикация новостей</li>
              <li>Создание турниров и матчей с трансляциями на ChessOpen</li>
              <li>
                Возможность проводить турниры по разным системам и с тонкой настройкой контроля и
                многие другие.
              </li>
            </ul>

            <p>
              Чтобы рассказать нам о своих планах и посмотреть демо нашего продукта для владельцев
              клубов, пожалуйста свяжитесь с аккаунт-менеджером по почте:
            </p>

            <p>
              <ThemeLink href="mailto:ak@chessrussian.ru">ak@chessrussian.ru</ThemeLink>
            </p>

            <p>
              С уважением,
              <br />
              команда ChessOpen
            </p>
          </div>
        </ModalCard>
      )}
    </>
  );
}
